<div
    class="form-group position-relative mb-0"
    [class.form-group-disabled]="disabled"
    [ngClass]="{ 'd-flex flex-row align-items-center': horizontal }">
    @if (label) {
        <label
            class="d-block text-nowrap"
            [attr.for]="identifier"
            [class.me-3]="horizontal"
            [class.mb-0]="horizontal"
            [class.mb-1]="!horizontal"
            >{{ label }}
            @if (isRequiredField) {
                <sup>*</sup>
            }
        </label>
    }

    <div class="input-group">
        <input
            class="form-control"
            type="text"
            placeholder=""
            bsDatepicker
            #calendar="bsDatepicker"
            [ngClass]="size ? 'form-control-' + size : null"
            [attr.id]="identifier"
            [bsValue]="control?.value"
            [disabled]="disabled ? true : null"
            [minDate]="minDate"
            [maxDate]="maxDate"
            (bsValueChange)="onCalendarChange($event)"
            (keyup)="onKeyUp($event)" />

        <button class="btn btn-outline calendar" type="button" [disabled]="disabled" (click)="calendar.toggle()"></button>
    </div>
</div>
